export default "__VITE_PUBLIC_ASSET__6772cbac__"